<template>
  <b-form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.id)">
    <div class="row">
      <div class="col">
        <b-card>
          <template #header>
            <b>Public Holiday</b>
          </template>

          <form-text v-model="form.name" name="name" maxlength="64" :required="true" />
          <form-select
            v-model="form.state"
            name="state"
            :options="['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']"
          />
          <form-date v-model="form.date" name="date" value-format="yyyy-MM-dd" />
        </b-card>
      </div>
    </div>

    <b-card-footer class="mb-5">
      <div class="row">
        <div class="col text-right">
          <button class="btn btn-primary" :disabled="form.notReady()">
            <font-awesome-icon v-if="form.busy" spin :icon="['fal', 'spinner']" />
            <font-awesome-icon v-else :icon="['fal', 'check']" />
            {{ crud.getAction() === "create" ? "Create" : "Save" }}
          </button>
        </div>
      </div>
    </b-card-footer>
  </b-form>
</template>

<script type="text/babel">
import format from "../../mixins/format";

export default {
  mixins: [format],

  data() {
    return {
      crud: null,
      form: new window.AppForm({
        name: null,
        state: null,
        date: null,
      }),
    };
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.crud = new window.AppCrud("public-holidays");

      this.form.reset();

      if (this.crud.getAction() !== "create") {
        this.crud.initFormData(this.form);
      }
    },

    onSubmit() {
      this.crud.submit(this.form).then((response) => {
        if (this.crud.getAction() === "create") {
          window.toastr.success("Public Holiday created!", "Success");

          this.$router.push(
            {
              name: "public-holidays.edit",
              params: { id: response.voucher.id },
            },
            () => {
              this.init();
            }
          );
        } else {
          this.init();
          window.toastr.success("Public Holiday updated!", "Success");
        }
      });
    },
  },
};
</script>
